import React from 'react';
import { Button } from 'reactstrap';
import IArticleQuantity from './interfaces/IArticleQuantity';

import { ReactComponent as MinusIcon } from '../assets/icons/minus.svg';
import { ReactComponent as PlusIcon } from '../assets/icons/plus.svg';

const ArticleQuantity = ({
  quantity, setQuantity, className: cn, maxQuantity,
} : IArticleQuantity) => {
  const isMinusButtonDisabled = quantity <= 1;
  const isPlusButtonDisabled = maxQuantity ? quantity >= maxQuantity : false;

  const quantitySectionStyle = `d-flex align-items-center ${cn}`;

  const addQuantity = () => {
    const newQuantity = quantity + 1;
    if (maxQuantity && newQuantity > maxQuantity) return;
    setQuantity(newQuantity);
  };

  const subQuantity = () => {
    const newQuantity = quantity - 1;
    if (newQuantity < 1) return;
    setQuantity(quantity - 1);
  };

  return (
    <div className={quantitySectionStyle}>
      <Button
        className="border button-quantity"
        onClick={subQuantity}
        disabled={isMinusButtonDisabled}
      >
        <MinusIcon />
      </Button>
      <h5 className="px-3 m-0">{quantity}</h5>
      <Button
        className="border button-quantity"
        onClick={addQuantity}
        disabled={isPlusButtonDisabled}
      >
        <PlusIcon />
      </Button>
    </div>
  );
};

export default ArticleQuantity;
